import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class StreetTypesService {
  constructor(private http: HttpClient) {}

  public fetchStreetTypes(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/streetTypes`
    return this.http.post(url, params)
  }
  public fetchStreetType(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/streetType/${id}`
    return this.http.get(url, {})
  }

  public deleteStreetType(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/streetType/${id}`
    return this.http.delete(url)
  }

  public createStreetType(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/streetType`
    return this.http.post(url, params)
  }

  public updateStreetType(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/streetType/${id}`
    return this.http.put(url, params)
  }
}
